import {
  set, observable, computed,
} from 'mobx';

export interface IUser {
  email: string;
  recognized: number;
  registered: number;
  userId: string;
  isGuestUser: number;
  hasLoyaltyEnabled: boolean;
  isProCustomer: boolean;
  firstName: string;
  lastName: string;
  nationalId?: string;
  isKeptSignedIn?: boolean;
}

class User {
  @observable email: string;

  @observable recognized: number;

  @observable registered: number;

  @observable userId: string;

  @observable isGuestUser: number;

  @observable hasLoyaltyEnabled: boolean;

  @observable isProCustomer: boolean;

  @observable firstName: string;

  @observable lastName: string;

  @observable nationalId?: string;

  @observable isKeptSignedIn?: boolean;

  @computed
  get isUserRegistered(): boolean {
    return !this.isGuestUser;
  }

  static fromJSON(data: IUser): User {
    const user = new User();
    set(user, data);

    return user;
  }
}

export default User;
